module.exports = __webpack_public_path__ + "img/apple-touch-icon.66830ea6.png";